<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <h3 class="card-title d-flex">
          Consult Astrology
          <a href="" target="_blank" class="ml-2">
            <vs-icon icon="info" size ="small" />
          </a>
        </h3>
        <p class="card-subtitle">List of Consult Astrology Data.</p>
        <vs-row>
          <vs-col vs-lg="3" vs-xs="12">
            <vs-select :color="colorx" label="Language Filter" v-model="search.language">
              <vs-select-item value="all" text="All Languages" />
              <vs-select-item :key="index" :value="item.culture" :text="item.culture"
                v-for="(item, index) in languages" />
            </vs-select>
          </vs-col>
          <vs-col vs-lg="3" vs-xs="12">
            <vs-select :color="colorx" label="App Type" v-model="search.app_type">
              <vs-select-item text="App Type" disabled />
              <vs-select-item value="all" text="All" />
              <vs-select-item value="bharat" text="Bharat" />
              <vs-select-item value="samvat" text="Samvat" />
              <vs-select-item value="business" text="Business" />
            </vs-select>
          </vs-col>
          <vs-col vs-lg="3" vs-xs="12">
            <vs-select :color="colorx" label="Day Filter" v-model="search.day">
              <vs-select-item value="0" text="All" />
              <vs-select-item value="1" text="Today" />
              <vs-select-item value="7" text="This Week" />
              <vs-select-item value="30" text="This Month" />
            </vs-select>
          </vs-col>
          <vs-col vs-lg="3" vs-xs="12">
            <vs-button color="primary" type="filled" class="searchBtn" @click="fetchAllConsultAstrology()"
              icon="search">Search</vs-button>
            <vs-button color="warning" type="filled" class="searchBtn" icon="cached"
              @click="resetData()">Reset</vs-button>
          </vs-col>
        </vs-row>
        <br />
        <table class="table">
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Mobile No</th>
            <th>Consultancy</th>
            <th>App Type</th>
            <th>Language</th>
            <th @click="sortByDate('date')" style="cursor: pointer;">Date
              <span v-if="sortByField === 'date'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
          </tr>
          <tr v-for="(item, index) in all" :key="index">
            <td>
              {{ current_page * data_per_page + index + 1 }}
            </td>
            <td class="td">{{ item.name }}</td>
            <td class="td">{{ item.phone }}</td>
            <td class="td">{{ item.consultancy }}</td>
            <td class="td">{{ item.app_type }}</td>
            <td class="td">{{ item.language }}</td>
            <td class="td">{{ moment(item.date) }}</td>
          </tr>
        </table>
        <div class="page-button-div">
          <vs-button type="filled" :class="current_page == page ? 'clicked' : 'pagination-button'"
            v-for="(page, index) in total_pages_array" @click="handleCurrentPage(page), handleClicked(page)"
            :key="index">{{ page + 1 }}</vs-button>
        </div>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import api from "@/rest.js";
import { API } from "@/common/constants";
import moment from "moment";

export default {
  name: "Consult Astrology",
  components: {},
  data: () => ({
    title: "Consult Astrology",
    colorx: "#0D2144",
    defaultalert: false,
    isNew: true,
    clone: false,
    sortByField: "",
    sortDirection: "asc",
    search: {
      language: "all",
      app_type: "all",
      day: "0",
    },
    all: [],
    total_data: 0,
    data_per_page: 25,
    page_count: 0,
    total_pages_array: [],
    current_page: 0,
    languages: [],
  }),
  computed: {
    sortedData() {
      if (this.sortByField) {
        return this.all.sort((a, b) => {
          if (this.sortDirection === "desc") {
            return a[this.sortByField] > b[this.sortByField] ? 1 : -1;
          } else {
            return a[this.sortByField] < b[this.sortByField] ? 1 : -1;
          }
        });
      }
      return this.all;
    },
  },
  methods: {
    sortByDate(field) {
      if (this.sortByField === field) {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      } else {
        this.sortByField = field;
        this.sortDirection = "asc";
      }
      this.all = this.sortedData;
    },
    moment: function (date) {
      return moment.utc(date).format("DD/MM/YYYY");
    },
    fetchAllConsultAstrology() {
      this.$vs.loading();
      api
        .get(API.GET_CONSULT_ASTROLOGY, {
          params: {
            page: this.current_page,
            size: this.data_per_page,
            language: this.$data.search.language,
            app_type: this.$data.search.app_type,
            day: this.$data.search.day,
          },
        })
        .then((r) => {
          this.$vs.loading.close();
          this.$data.all = r.data;
          if (!r.status) {
            this.$vs.notify({
              title: "Error",
              text: r.data.message,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    fetchDataCount() {
      this.$vs.loading();
      api
        .get(API.GET_CONSULT_ASTROLOGY_COUNT)
        .then((r) => {
          this.$vs.loading.close();
          this.$data.total_data = r.data;
          this.$data.page_count = Math.ceil(
            r.data / this.$data.data_per_page
          );
          this.$data.total_pages_array = [
            ...Array(this.$data.page_count).keys(),
          ];
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    handleCurrentPage(page) {
      this.$data.current_page = page;
      this.fetchAllConsultAstrology();
    },
    handleClicked(page) {
      if (this.$data.current_page === page) {
        this.$data.button_css = "clicked";
      } else {
        this.$data.button_css = "not-clicked";
      }
    },
    fetchAllLanguages() {
      this.$vs.loading();
      api
        .get(API.GET_LANG, {})
        .then((r) => {
          this.$vs.loading.close();
          this.$data.languages = r.data
        })
        .catch(() => {
          this.$vs.notify({
            text: "Error Deleting",
            color: "danger",
            position: "top-right",
          });
          this.$vs.loading.close();
        });
    },
    resetData() {
      this.$data.search = {
        language: "all",
        app_type: "all",
        day: "0",
      };
      this.fetchAllConsultAstrology();
    },
  },
  created() {
    this.fetchAllConsultAstrology();
    this.fetchAllLanguages();
    this.fetchDataCount();
    if (!this.$data.search.language) {
      this.$data.search.language = "all";
    }
  },
};
</script>
<style scoped>
.mb15 {
  margin-bottom: 15px;
}

.td {
  vertical-align: middle;
}

.mt20 {
  margin-top: 20px;
}

.searchBtn {
  margin-top: 25px;
  margin-right: 5px;
  width: 30%;
}

.page-button-div {
  display: flex;
  justify-content: center;
  width: 100%;
}

.pagination-button {
  background-color: transparent !important;
  border: 1px solid rgba(121, 121, 125, 0.326);
  color: black;
  margin-right: 10px;
}

.clicked {
  background-color: rgba(0, 0, 205, 0.768) !important;
  border: 1px solid rgba(0, 0, 205, 0.768);
  color: white;
  font-weight: 700;
  margin-right: 10px;
}
</style>
